import { VueFinalModal, useModal as useFinalModal, useModalSlot, useVfm } from 'vue-final-modal'
import { h, watch } from 'vue'

interface ModalAttrs {
  zIndexFn?: ({ index }: { index: number }) => number;
  contentClass?: string | string[];
  clickToClose?: boolean;
  [key: string]: any;
}

export function useModal() {
  const modal = {
    show(component: any, props: any, attrs: ModalAttrs = {}) {
      attrs = {
        zIndexFn: ({ index }: { index: number }) => 1040 + 2 * index,
        clickToClose: true,
        ...attrs,
      };

      const hmModalClasses = ['hm-modal'];
      if (attrs.contentClass) {
        if (Array.isArray(attrs.contentClass)) {
          hmModalClasses.push(...attrs.contentClass);
        } else if (typeof attrs.contentClass === 'string' && attrs.contentClass.trim() !== '') {
          hmModalClasses.push(attrs.contentClass);
        }
        delete attrs.contentClass;
      }

      const modal = useFinalModal({
        component: VueFinalModal,
        attrs: {
          ...attrs,
        },
        slots: {
          default: useModalSlot({
            component: {
              setup() {
                return () => h('div', { class: hmModalClasses.join(' ') }, [
                  h('div', {
                    class: 'hm-modal_overlay',
                    onClick: (event: Event) => {
                      if (
                        event.target === event.currentTarget &&
                        attrs.clickToClose !== false
                      ) {
                        modal.close();
                      }
                    }
                  }),
                  h(component, {
                    ...props,
                    _close: () => modal.close(),
                  })
                ])
              }
            },
          }),
        }
      });
      const { patchOptions } = modal;
      watch(
        () => attrs,
        newVal => {
          patchOptions({ attrs: newVal });
        }
      );
      modal.open();
      return modal;
    },
    hideAll() {
      const vfm = useVfm();
      vfm.closeAll();
    }
  };

  return modal;
}
